<template>
  <div class="section">
    <div class="box">
      <div class="title">Events</div>
      <div class="subtitle is-size-6 has-text-grey">Here, you can subscribe to several events, when one happens you'll get an email letting you know</div>
      <div class="event-list">
        <div class="event" v-for="event in events" :key="event.event_id">
          <div class="columns">
            <div class="column is-capitalized is-size-5">{{ event.event_name | eventName }}</div>
            <div class="column"><b-switch @input="ToggleEventSub(event, $event)" v-model="event.subscribed" size="is-medium"></b-switch></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: function () {
    return {
      newApiUrl: "https://api.jeak.co.uk",
      events: [],
    };
  },
  methods: {
    GetEvents: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const response = await axios.get(this.newApiUrl + `/notification/events`, config);
      this.events = response.data;
    },
    SubscribeToEvent: async function (eventId, userEmail) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        email: userEmail,
        eventId: eventId,
      };
      const response = await axios.post(this.newApiUrl + `/notification/subscribe`, body, config);
    },
    UnsubscribeFromEvent: async function (userEmail, eventId) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        email: userEmail,
        eventId: eventId,
      };
      const response = await axios.post(this.newApiUrl + `/notification/unsubscribe`, body, config);
    },
    ToggleEventSub: function (event, eventData) {
      if (eventData == true) {
        this.SubscribeToEvent(event.event_id, this.$route.params.email);
      } else {
        this.UnsubscribeFromEvent(this.$route.params.email, event.event_id);
      }
    },
  },
  computed: {},
  filters: {
    eventName: function (string) {
      let newString = string.replace("_", " ");
      return newString;
    },
  },
  mounted() {
    this.GetEvents();
  },
};
</script>

<style scoped></style>
